import { useIntl } from "react-intl";

import { useSearchParameters } from "@/components/signup/hooks";
import { ProductKey } from "@/components/signup/utils";
import { CardsGrid } from "@/templates/ondemand/signup/confirmation/confirmation-page/src/views/user-seg-bxp-ui/cards-grid.tsx";
import { ExperimentView, experiments } from "@/utils/experiment";

import { JiraOnboardingContainer } from "../jira/jira-onboarding-container/jira-onboarding-container";
import { ServCoOnboardingContainer } from "../serv-co/serv-co-onboarding-container/serv-co-onboarding-container";
import { TwcOnboardingContainer } from "../twc-provisioning-screen/components/twc-onboarding-container";

type MessagesType = {
    readonly teamFocus: string;
    readonly personalizeJira: string;
};

const TeamFocusView = () => {
    const intl = useIntl();
    const searchParameters = useSearchParameters();
    const { products = [] } = searchParameters;

    const isJsm = products.includes(ProductKey.JIRA_SERVICE_MANAGEMENT);
    const isServCo = products.includes(ProductKey.SERVICE_COLLECTION);
    const isTwc = products.includes(ProductKey.TEAMWORK_COLLECTION);

    if (isTwc) {
        return (
            <TwcOnboardingContainer
                header={intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.twc.jtbdD0onboarding.header",
                    defaultMessage: "What kind of work do you do?"
                })}
                subheader={intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.twc.jtbdD0onboarding.subHeader",
                    defaultMessage: "This helps us personalize your experience."
                })}
            >
                <CardsGrid />
            </TwcOnboardingContainer>
        );
    }

    const messages: MessagesType = isJsm
        ? {
              teamFocus: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.header",
                  defaultMessage: "What kind of work do you do?"
              }),
              personalizeJira: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.jsm.subHeader",
                  defaultMessage: "This helps us personalize your experience"
              })
          }
        : {
              teamFocus: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.header",
                  defaultMessage: "What kind of work do you do?"
              }),
              personalizeJira: intl.formatMessage({
                  id: "UserSeg.teamTypeSelection.transparentTemplateForAll.subHeader",
                  defaultMessage:
                      "This helps us suggest templates that help your team do their best work."
              })
          };

    const jiraOnboardingContainer = (
        <JiraOnboardingContainer
            header={messages.teamFocus}
            subheader={messages.personalizeJira}
        >
            <CardsGrid />
        </JiraOnboardingContainer>
    );

    if (!isJsm && !isServCo) {
        return jiraOnboardingContainer;
    }

    const servCoMessages: MessagesType = {
        teamFocus: intl.formatMessage({
            id: "UserSeg.teamTypeSelection.header",
            defaultMessage: "What kind of work do you do?"
        }),
        personalizeJira: intl.formatMessage({
            id: "UserSeg.teamTypeSelection.transparentTemplateForAll.subHeader",
            defaultMessage:
                "This helps us suggest templates that help your team do their best work."
        })
    };

    return (
        <ExperimentView
            experiment={experiments.servCoLofiBackground}
            render={(value) =>
                value ? (
                    <ServCoOnboardingContainer
                        header={servCoMessages.teamFocus}
                        subheader={servCoMessages.personalizeJira}
                    >
                        <CardsGrid />
                    </ServCoOnboardingContainer>
                ) : (
                    jiraOnboardingContainer
                )
            }
        />
    );
};

export default TeamFocusView;
